angular.module('dat.shared-components.location', [
	'dat.shared-components.common',
	'Scope.safeApply'
]);
